var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import DashboardPanel from './DashboardPanel';
import { typicaStockItem as api } from '../../../api';
import { useRequest } from '../../../hooks/requestHook';
import { CircularProgress } from '@mui/material';
import TypicaStockItemDelaySummaryChart from './TypicaStockItemDelaySummaryChart';
import OfferListSelect from '../../organisms/OfferListSelect';
var TypicaStockItemDelaySummaryPanel = function () {
    var t = useTranslation().t;
    var getDelaySummary = useRequest(api.getDelaySummary);
    var _a = React.useState(), summary = _a[0], setSummary = _a[1];
    var _b = React.useState(), offerList = _b[0], setOfferList = _b[1];
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, getDelaySummary({
                            offer_list_id: (_a = offerList === null || offerList === void 0 ? void 0 : offerList.id) !== null && _a !== void 0 ? _a : '',
                        })];
                    case 1:
                        response = _b.sent();
                        if (!response || canceled)
                            return [2 /*return*/];
                        setSummary(response);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [getDelaySummary, offerList === null || offerList === void 0 ? void 0 : offerList.id]);
    return (React.createElement(DashboardPanel, { title: t('pages.dashboard.typicaStockItemDelaySummaryPanel.title'), gridProps: {
            xs: 12,
            md: 6,
        } },
        !summary && React.createElement(CircularProgress, null),
        summary && (React.createElement(React.Fragment, null,
            React.createElement(OfferListSelect, { query: {
                    q: {
                        have_typica_stock_items: true,
                    },
                }, value: offerList, onChange: setOfferList }),
            React.createElement(TypicaStockItemDelaySummaryChart, { title: t('pages.dashboard.typicaStockItemDelaySummaryPanel.chartTitleFromImported'), baseUrl: "/admin/typica_stock_items", offerList: offerList, summaryData: summary.quantitiesFromImported }),
            React.createElement(TypicaStockItemDelaySummaryChart, { title: t('pages.dashboard.typicaStockItemDelaySummaryPanel.chartTitleFromPurchased'), baseUrl: "/admin/warehouse_items", offerList: offerList, summaryData: summary.quantitiesFromPurchased })))));
};
export default TypicaStockItemDelaySummaryPanel;
